import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector, inject, ChangeDetectionStrategy } from '@angular/core';
import { Utyji05Component } from './utyji05Pkg.component';
import { Utyji05DetailComponent } from './utyji05-detailPkg.component';
import { MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';

@Component({
  selector: 'app-utyji05-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Utyji05Component,
    Utyji05DetailComponent,
  ],
  templateUrl: './utyji05BillPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Utyji05BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' utyji05'; //###
  override masterPage!: Utyji05Component;
  override detailPage!: Utyji05DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
